export const sampleSource = `{
  "assigned_location_id": 3183479,
  "destination": {
    "id": 54433189,
    "zip": "K2P0V6",
    "city": "Ottawa",
    "email": "bob@customer.com",
    "phone": "(555)555-5555",
    "company": "",
    "country": "Canada",
    "address1": "123 Amoebobacterieae St",
    "address2": "Unit 806",
    "province": "Ontario",
    "last_name": "Bobsen",
    "first_name": "Bob"
  },
  "line_items": [
    {
      "id": 123456789987,
      "shop_id": 3998762,
      "quantity": 3,
      "price": 32.78,
      "variant_id": 2385087,
      "line_item_id": 466157049,
      "inventory_item_id": 123456789987,
      "fulfillable_quantity": 1,
      "fulfillment_order_id": 1568020,
      "token": "",
      "position": 2
    },
    {
      "id": 123456789987,
      "shop_id": 3998762,
      "quantity": 2,
      "price": 12.98,
      "variant_id": 2385088,
      "line_item_id": 466157040,
      "inventory_item_id": 123456789987,
      "fulfillable_quantity": 1,
      "fulfillment_order_id": 1568021,
      "token": "",
      "position": 2
    },
    {
      "id": 123456789987,
      "shop_id": 3998762,
      "quantity": 3,
      "price": 9.92,
      "variant_id": 2385089,
      "line_item_id": 466157041,
      "inventory_item_id": 123456789987,
      "fulfillable_quantity": 1,
      "fulfillment_order_id": 1568022,
      "token": "",
      "position": 2
    }
  ],
  "order_id": 3183479,
  "request_status": "unsubmitted",
  "shop_id": 255858046,
  "status": "open",
  "assigned_location": {
    "zip": "K2P0V6",
    "city": "Ottawa",
    "name": "Bob Bobsen",
    "phone": "(555)555-5555",
    "address1": "123 Amoebobacterieae St",
    "address2": "Unit 806",
    "province": "Ontario",
    "location_id": 17232953366,
    "country_code": "CA"
  }
}`;

export const sampleJsonataExpression = `($sum(line_items.(price * quantity)) ~> $string) & " USD"`;
